export enum DisplayModeEnum {
  SEO_OPTIMIZED = 'seoOptimized',
  NON_SEO_OPTIMIZED = 'nonSeoOptimized',
}

export type DisplayMode = Readonly<{ kind: DisplayModeEnum }>;
